import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";
import { myBag } from "../models";

const initialState = {
  id: "",
  items: [],
  isfetchCartComplete: false
};

export default {
  name: "cart",
  actions: {
    updateCart: payload => dispatch({ type: "UPDATE_CART", payload }),
    addToCart: async function (order) {
      dispatch({ type: "ADD_TO_CART" });

      const response = await fetch(`${HOST_URL}/shopping/v1/cartItems`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(order),
        credentials: "include"
      });
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "updateCart",
          response.status,
          response.statusText
        );
      }
      // await req.post({
      //   api: "insertCart",
      //   body: order
      // });
    },
    fetchCart: async function () {
      dispatch({ type: "FETCH_CART" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/miniCart`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        const bag = document.getElementById("modal_shoppingBag");
        if (bag) {
          window.postMessage("UPDATE_MINI_CART", "*");
        }
        // 將資料存入 window
        window.miniCart = data;
        this.updateCart(data);
      } else {
        window.logApiErrors(
          "r",
          "fetchCart",
          response.status,
          response.statusText
        );
      }
    },
    removeCartItem: async function (cartId) {
      dispatch({ type: "REMOVE_CART_ITEM" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/cartItems/${cartId}`,
        {
          credentials: "include",
          method: "DELETE",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (!response.ok) {
        window.logApiErrors(
          "r",
          "removeCartItem",
          response.status,
          response.statusText
        );
      }
      await this.fetchCart();
      await myBag.actions.fetchMyBag();
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_CART":
        return Object.assign({}, action.payload, { isfetchCartComplete: true });
      default:
        return state;
    }
  }
};
